import buttonBack from '@/assets/btn/back.png';
import { Sound } from '@/classes';
import { keyCodes } from '@/constants/keyCode';
import { useExtendFocusable } from '@/hooks/useExtendFocusable';
import { useRouter } from '@/hooks/useRouter';
import { FocusableImage } from '@/shared/ui';
import { DeviceInfo } from '@/widgets/device-info';
import { FocusContext } from '@noriginmedia/norigin-spatial-navigation';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const CsPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { ref, focusKey, focusSelf, focused } = useExtendFocusable({ focusKey: 'backButton' });

  useEffect(() => {
    const focusing = (e: KeyboardEvent) => {
      switch (e.keyCode) {
        case keyCodes.UP:
        case keyCodes.DOWN:
        case keyCodes.LEFT:
        case keyCodes.RIGHT: {
          focusSelf();
          break;
        }
        case keyCodes.ENTER: {
          if (focused) {
            Sound.press();
            router.pop();
          }
          break;
        }
      }
    };
    document.addEventListener('keydown', focusing);

    return () => {
      document.removeEventListener('keydown', focusing);
    };
  }, [focusSelf, focused, router]);

  const onClick = useCallback(() => {
    router.pop();
  }, [router]);

  useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className="flex flex-col h-screen">
        <header className="bg-[#0F2648] h-[210px] text-[60px] text-white text-bold flex flex-col">
          <div className="flex items-center my-[60px]">
            <FocusableImage
              focusKey="backButton"
              src={buttonBack}
              className={`ml-[74px] p-[20px] rounded-[20px] outline-disable`}
              style={focused ? { background: '#FF66AE' } : {}}
              onClick={onClick}
            />
            <span className="ml-[61px]">{t('mypage_menu_support')}</span>
          </div>
        </header>
        <main
          className="py-[75px] px-[223px] text-[#1B1B1B] bg-[#F1F1F1]"
          style={{
            height: 'calc(100vh - 210px)',
          }}
        >
          <h1 className="text-[46px] font-bold">{t('mypage_menu_support')}</h1>
          <h5 className="text-[34px] whitespace-pre">{t('page_support')}</h5>
          <h1 className="text-[46px] font-bold mt-8">{t('mypage_menu_device_info')}</h1>
          <h5 className="text-[34px]">{t('page_device_info')}</h5>
          <DeviceInfo />
        </main>
      </div>
    </FocusContext.Provider>
  );
};
